import React, { createContext, useContext, useState } from 'react';

const ApprovalRequestContext = createContext();

export const useApprovalRequest = () => {
  const context = useContext(ApprovalRequestContext);
  if (!context) {
    throw new Error('useApprovalRequest must be used within an ApprovalRequestProvider');
  }
  return context;
};

export const ApprovalRequestProvider = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);

  const updatePendingCount = (count) => {
    console.log("🚀 ~ ApprovalRequestContext ~ updatePendingCount called with:", count);
    setPendingCount(count);
  };

  return (
    <ApprovalRequestContext.Provider value={{ pendingCount, updatePendingCount }}>
      {children}
    </ApprovalRequestContext.Provider>
  );
};
